import type { IAuth } from '../../domain/use-cases/i-auth'

export class AuthController {
  constructor(private readonly repository: IAuth) {}
  async getToken(): Promise<string> {
    try {
      const result = await this.repository.getToken()
      return result
    } catch (error) {
      throw error
    }
  }
}
